<template>
  <component
    :is="layoutComponent"
    v-bind="layoutProps"
    v-if="show">
    <template slot="field">
      <textarea
        v-if="!highlight"
        :id="field.attribute"
        v-model="fieldValue"
        :cols="inputCols"
        :rows="inputRows"
        :maxlength="inputMaxlength"
        :placeholder="inputPlaceholder"
        :readonly="isReadonly"
        :disabled="isDisabled"
        v-bind="field.attrs"
        class="form-control"
        :class="[
          'form-control',
          errorClasses,
          depends ? 'depend-textarea' : ''
        ]"
      />
      <AceEditor
        v-else
        v-model="fieldValue"
        :options="{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          fontSize: 12,
          wrap: true,
          indentedSoftWrap: false,
          highlightActiveLine: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
          showPrintMargin: false,
          showGutter: true,
          maxLines: Infinity,
          minLines: 5
        }"
        :lang="highlight"
        theme="xcode"
        width="100%"
        @init="editorInit"
      />
      <div
        v-if="inputMaxlength && fieldValue && fieldValue.length"
        class="maxlength_dump"
      >
        {{ fieldValue.length }}/{{ inputMaxlength }}
      </div>
    </template>
  </component>
</template>

<script>
import { FormTextareaField } from "stylemix-base";
import AceEditor from "vuejs-ace-editor";

export default {
  name: "TextareaHighlightField",
  components: {
    AceEditor
  },
  extends: FormTextareaField,

  data() {
    return {
      show: true,
      depends: false,
      highlight: null
    };
  },
  mounted() {
    if (this.field.highlight) this.highlight = this.field.highlight;
  },
  methods: {
    dataSumit() {
      //code here
    },
    editorInit: function() {
      require("brace/ext/language_tools");
      require("brace/mode/html");
      require("brace/mode/javascript");
      require("brace/mode/less");
      require("brace/theme/xcode");
      require("brace/snippets/" + this.highlight);
    }
  }
};
</script>
<style>
.form-group {
  position: relative;
}
.maxlength_dump {
  position: absolute;
  right: 0;
  bottom: 0;
  border: 1px solid #dadada;
  background-color: #f3f3f3;
  padding: 1px 4px;
}
.ace-xcode {
  border: 1px solid #dadada;
}
</style>
